import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { Image, Message, Label, Header } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

// 훈련 실시의 템플릿 Option 리스트
class TemplateOptionList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { templateData, templateAttach, templateAttachIndex } = this.props;

    // 첨부파일 정보
    let attachContent = '-';
    const attachInfo = templateAttach.get(String(templateAttachIndex.get(String(templateData.attachInfoNo))));
    const isAttach = attachInfo && attachInfo.get('isEnable') === 1 ? true : false;
    // 템플릿 생성 유형
    const tempCreateType = templateData.serviceNo ? (
      <Label basic size="small" className={cx('temp-examType color-temp-user')}>
        {defineMessages(formatMessage({ id: 'StartExamWizardContent_38', defaultMessage: '사용자' }))}
      </Label>
    ) : (
      <Label basic size="small" className={cx('temp-examType color-temp-system')}>
        {defineMessages(formatMessage({ id: 'StartExamWizardContent_39', defaultMessage: '기 본' }))}
      </Label>
    );
    // 템플릿 실행 결과
    let tempExamType;
    if (isAttach) {
      if (templateData.examType === 1 && attachInfo.get('attachExamType') === 1) {
        tempExamType = (
          <Label basic size="small" className={cx('temp-examType color-temp-warning')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_95', defaultMessage: '경고 안내' }))}
          </Label>
        );
      } else if (templateData.examType === 1 && attachInfo.get('attachExamType') === 2) {
        tempExamType = (
          <Label basic size="small" className={cx('temp-examType color-temp-file')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_88', defaultMessage: '모의 악성파일' }))}
          </Label>
        );
      } else if (templateData.examType === 1 && attachInfo.get('attachExamType') === 3) {
        tempExamType = (
          <Label basic size="small" className={cx('temp-examType color-temp-research')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_89', defaultMessage: '실태 조사' }))}
          </Label>
        );
      }
    }
    if (templateData.examType === 4) {
      tempExamType = templateData.examType === 4 && (
        <Label basic size="small" className={cx('temp-examType color-temp-phishing')}>
          {defineMessages(formatMessage({ id: 'StartExamWizardContent_92', defaultMessage: '피싱 유도' }))}
        </Label>
      );
    }

    // 수신 성공 여부
    // const tempReceive =
    //   templateData.templateReceive === 1 ? (
    //     <span className={cx('brand')}>
    //       {defineMessages(formatMessage({ id: 'StartExamWizardContent_46', defaultMessage: '성공' }))}
    //     </span>
    //   ) : (
    //     defineMessages(formatMessage({ id: 'StartExamWizardContent_47', defaultMessage: '미확인' }))
    //   );

    let tempLinkAttach = defineMessages(formatMessage({ id: 'ExamTemplateEdit_17', defaultMessage: '첨부 없음' }));
    if (templateData.linkAttach === 1) {
      tempLinkAttach = defineMessages(formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' }));
    } else if (templateData.linkAttach === 2) {
      tempLinkAttach = defineMessages(formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' }));
    } else if (templateData.linkAttach === 3) {
      tempLinkAttach = defineMessages(formatMessage({ id: 'ExamTemplateList_31', defaultMessage: '링크 + 첨부' }));
    }

    // 훈련실시(Step4) - 템플릿 통계
    let tempStatistics = defineMessages(
      formatMessage({ id: 'StartExamWizardContent_99', defaultMessage: '훈련 결과 없음' })
    );

    // 기본 템플릿만 통계가 나옴
    if (!templateData.serviceNo && templateData.statisticsTarget > 0) {
      const statisticsPercent =
        ' : ' + Math.floor(templateData.statisticsInfection / templateData.statisticsTarget * 100) + ' %';
      if (templateData.examType === 4) {
        tempStatistics = defineMessages(formatMessage({ id: 'StartExamWizardContent_98', defaultMessage: '유출율' }));
      } else {
        tempStatistics = defineMessages(formatMessage({ id: 'StartExamWizardContent_97', defaultMessage: '감염율' }));
      }
      tempStatistics = tempStatistics + statisticsPercent;
    } else {
      //
    }

    // 삭제된 항목은 제거
    if (isAttach) {
      const attachCategory =
        (attachInfo.get('attachCategory') === 1 && (
          <Label basic size="small" className={cx('temp-attachExamType color-attach-exe')}>
            {defineMessages(formatMessage({ id: 'ExamAttachCategory_1', defaultMessage: '실행파일' }))}
          </Label>
        )) ||
        (attachInfo.get('attachCategory') === 2 && (
          <Label basic size="small" className={cx('temp-attachExamType color-attach-lnk')}>
            {defineMessages(formatMessage({ id: 'ExamAttachCategory_2', defaultMessage: '바로가기' }))}
          </Label>
        )) ||
        (attachInfo.get('attachCategory') === 3 && (
          <Label basic size="small" className={cx('temp-attachExamType color-attach-doc')}>
            {defineMessages(formatMessage({ id: 'ExamAttachCategory_3', defaultMessage: '문서파일' }))}
          </Label>
        )) ||
        (attachInfo.get('attachCategory') === 4 && (
          <Label basic size="small" className={cx('temp-attachExamType color-attach-html')}>
            {defineMessages(formatMessage({ id: 'ExamAttachCategory_4', defaultMessage: '웹문서' }))}
          </Label>
        ));

      const fileIcon = (
        <Image
          className={cx('file-icon-image')}
          src={'/fdata/attachFile/' + attachInfo.get('attachInfoNo') + '/' + attachInfo.get('fileIcon')}
        />
      );
      const fileExt = <div className={cx('file-ext')}>{attachInfo.get('fileExt')}</div>;

      const attachFuncKey = Object.keys(JSON.parse(attachInfo.get('attachFunction')));
      const attachFunction = attachFuncKey.map((keys, i) => {
        return (
          <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachFunction')}>
            {keys}
          </Label>
        );
      });

      const attachResKey = Object.keys(JSON.parse(attachInfo.get('attachRestrict')));
      const attachRestrict = attachResKey.map((keys, i) => {
        return (
          <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachRestrict')}>
            {keys}
          </Label>
        );
      });

      const attachSubject = <div className={cx('attach-subject')}>{attachInfo.get('attachSubject')}</div>;
      attachContent = (
        <div className={cx('attach-area')}>
          <div className={cx('attach-title')}>
            {defineMessages(formatMessage({ id: 'ExamTemplateList_33', defaultMessage: '첨부파일 정보' }))}
          </div>
          {/* No */}
          <div className={cx('attach-no')}>{'no.' + attachInfo.get('attachInfoNo')}</div>
          {/* 첨부 구분 */}
          {/* 파일 아이콘 */}
          {fileIcon}
          {/* 파일 확장자 */}
          {fileExt}
          {/* 첨부 생성 유형 */}
          {/* {attachExamType} */}
          {/* 부가기능 */}
          {/* {attachFunction} */}
          {/* 제약사항 */}
          {/* {attachRestrict} */}
          {/* 첨부파일 제목 */}
          {/* {attachSubject} */}
        </div>
      );
    }

    return (
      <Header as="h6" size="tiny" className={cx('template-info')}>
        <Tooltip
          title={
            (templateData.examType === 1 &&
              isAttach &&
              attachInfo.get('attachExamType') === 1 &&
              defineMessages(formatMessage({ id: 'StartExamWizardContent_95', defaultMessage: '경고 안내' }))) ||
            (templateData.examType === 1 &&
              isAttach &&
              attachInfo.get('attachExamType') === 2 &&
              defineMessages(formatMessage({ id: 'StartExamWizardContent_88', defaultMessage: '모의 악성파일' }))) ||
            (templateData.examType === 1 &&
              isAttach &&
              attachInfo.get('attachExamType') === 3 &&
              defineMessages(formatMessage({ id: 'StartExamWizardContent_89', defaultMessage: '실태 조사' }))) ||
            (templateData.examType === 4 &&
              defineMessages(formatMessage({ id: 'StartExamWizardContent_92', defaultMessage: '피싱 유도' })))
          }
          placement="bottom">
          <Image
            className={cx('tempInfo-image')}
            src={
              '/img/examStart/temp_' +
              // 경고 안내
              ((templateData.examType === 1 && isAttach && attachInfo.get('attachExamType') === 1 && 'warning') ||
                // 모의 악성파일
                (templateData.examType === 1 && isAttach && attachInfo.get('attachExamType') === 2 && 'file') ||
                // 실태 조사
                (templateData.examType === 1 && isAttach && attachInfo.get('attachExamType') === 3 && 'research') ||
                // 피싱 유도
                (templateData.examType === 4 && 'phishing') ||
                // 값이 없을때
                'none') +
              '_36' +
              (templateData.templateReceive === 1 ? '_brand' : '') +
              '.png'
            }
          />
        </Tooltip>
        <Header.Content className={cx('template-name')}>
          <span className={cx('template-no')}>
            {'(No: ' +
              (!!templateData.serviceTemplateNo ? templateData.serviceTemplateNo : templateData.templateNo) +
              ')'}
          </span>

          {templateData.templateName}
          <Header.Subheader className={cx('template-summary')}>
            {/* 템플릿 생성 유형 */}
            {tempCreateType}
            {/* 템플릿 실행 결과 */}
            {tempExamType}
            {templateData.examType !== 4 ? ' / ' : null}
            {/* 다운로드 유형 */}
            {templateData.examType !== 4 ? tempLinkAttach : null}
            {' / '}
            {/* 수신 성공 여부 */}
            {tempStatistics}
            {/* {templateReceive} */}
          </Header.Subheader>
          {/* 피싱 훈련은 첨부파일 안나옴 */}
          {templateData.examType !== 4 && (
            <Header.Subheader className={cx('template-summary')}>
              {/* 첨부파일 정보 */}
              {attachContent}
            </Header.Subheader>
          )}
        </Header.Content>
      </Header>
    );
  }
}

const mapStateToProps = state => ({
  templateAttach: state.templateAttach.getIn(['data', 'success']),
  templateAttachIndex: state.templateAttach.get('listIndexByNo')
});

export default connect(mapStateToProps)(injectIntl(TemplateOptionList));



// WEBPACK FOOTER //
// ./src/script/components/exam-start/TemplateOptionList.js